// @ts-ignore
import('./bootstrap')
